import React, {Component} from 'react';
import axios from 'axios';
import '../tools/css/Ajustes.css';
import Date from '../components/DataPicker';
import BtnSave from '../components/BtnSave';
import BtnCancel from '../components/BtnCancel';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';
import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

var mensaje='';





class Ajustes extends Component {

  constructor()
    {
     super()
      this.state={
        show:false
      }
    }

    componentDidMount(){

      $('[data-toggle="tooltip"]').tooltip()

    }
    
    handleModalnewcontrato()
    {
      this.setState({show:!this.state.show})
      $('#modal-newcontrato').modal('show'); // <- to show modal crear contrato 
    }

    handleModaleditcontrato()
    {
      this.setState({show2:!this.state.show2})
      $('#modal-editcontrato').modal('show'); // <- to show modal editar contrato 
    }

    saverecurso=async()=>{
   
        await axios.get("https://video.twilio.com/v1/Compositions/CJ6186488b9d6f44f85ae2ed6b490fb7b7/Media?Ttl=3600",{
          headers: {'Authorization': 'Basic '+"U0s4ZGM4YzZhYzlmMmM5ZTdhNmNiOWJmNDhlYTc3MTUyNjpTQmFxNktYSVh6UFF4NjZEaEVyejNFVTV5MG80bXRtNg=="
        }
        })  
  
        .then(response=>{
          console.log(response.data)

          mensaje  = response.data.message;
         
          //this.setState({
            //Type_servicenew:response.data.agreement.typeServiceAgreements,
            //Servi_convenionew:response.data.agreement.serviceAgreements
          //})
          //alert(dato);
          //const [text, setText] = LocalStorage(text, '')
          //setText(dato);
                 
          //window.location.href="/home";
          store.addNotification({
            title: 'Muy bien',
            message: mensaje,
            type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

          
        })
        .catch(error=>{
          
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            //console.log(error.response.data.message);
            //console.log(error.response.status);
            //console.log(error.response.headers);
            mensaje=error.response.data.message
            
            store.addNotification({
              title: 'Error',
              message: mensaje,
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
        } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
        }
        //console.log(error.config);
      
      })

  
     }
       

    render(){  

     return (

     
      <div className="content-wrapper">

            <div className="col-12 col-sm-12">

              <div className="row">

                   <div className="col-sm-10">
                    <br></br>
                      <div className="text-center" id="title"> <h6> <b> AJUSTES </b>  </h6> </div>
                   
                   </div>                   
                   

              </div> 

      <div className="card card-primary card-outline card-tabs">
              <div className="card-header p-0 pt-1 border-bottom-0">
      
              </div>
          <div className="card-body">
            <div className="tab-content" id="custom-tabs-three-tabContent">
             
                
              <div className="card">
        
                {/* /.card-header */}
                <div className="card-body">
      
                  <div className="row"> 
      
      
                      <div className="col-sm-3">
             
                        <a type="button" id="btn-options" className="btn btn-secondary btn-lg" href="/contratos">Contratos <br/>
                           <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-folder-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                           </svg>
                        </a>
             
                     </div>  
      
                     <div className="col-sm-3">
             
                        <a type="button" id="btn-options" className="btn btn-secondary btn-lg" href="/consentimientos">Consentimientos <br/>
                          <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-file-text-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                          </svg>
                        </a>
             
                     </div> 

                      <div className="col-sm-3">
              
                        <a type="button" id="btn-options" className="btn btn-secondary btn-lg" href="/crear_usuarios">Crear Usuarios <br/>
                          <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-people-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                          </svg>
                        </a>
      
                      </div>                    

                      <div className="col-sm-3">
              
                        <a type="button" id="btn-options" className="btn btn-secondary btn-lg" href="/cuotasmoderadoras">Cuota Moderadora <br/>
                         <svg height="3em" viewBox="0 0 28 28" width="3em" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 5c-.655 0-.66 1.01 0 1h22c.286 0 .5.214.5.5v13c0 .66 1 .66 1 0v-13c0-.822-.678-1.5-1.5-1.5h-22zm-2 2c-.654 0-.654 1 0 1h22c.286 0 .5.214.5.5v13c0 .665 1.01.66 1 0v-13c0-.822-.678-1.5-1.5-1.5h-22zm-2 2C.678 9 0 9.678 0 10.5v12c0 .822.678 1.5 1.5 1.5h22c.822 
                          0 1.5-.678 1.5-1.5v-12c0-.822-.678-1.5-1.5-1.5h-22zm0 1h22c.286 0 .5.214.5.5v12c0 .286-.214.5-.5.5h-22c-.286 0-.5-.214-.5-.5v-12c0-.286.214-.5.5-.5zm1 1c-.276 0-.5.224-.5.5v2c0 .672 1 .656 1 0V12h1.5c.672 0 .656-1 0-1h-2zm10 0C9.468 11 7 13.468 7 16.5S9.468 22 12.5 22s5.5-2.468 5.5-5.5-2.468-5.5-5.5-5.5zm8 0c-.656 0-.672 1 0 1H22v1.5c0 .656 1 .672 1 0v-2c0-.276-.224-.5-.5-.5h-2zm-8 1c2.49 0 4.5 2.01 4.5 4.5S14.99 21 12.5 21 8 18.99 8 16.5s2.01-4.5 4.5-4.5zm0 1c-.277 0-.5.223-.5.5v.594c-.578.21-1 .76-1 1.406 0 .82.68 1.5 1.5 1.5.28 0 .5.212.5.5 0 .288-.22.5-.5.5h-1c-.338-.005-.5.248-.5.5s.162.505.5.5h.5v.5c0 .277.223.5.5.5s.5-.223.5-.5v-.594c.578-.21 1-.76 1-1.406 0-.82-.68-1.5-1.5-1.5-.28 0-.5-.212-.5-.5 0-.288.22-.5.5-.5h1c.338.005.5-.248.5-.5s-.162-.505-.5-.5H13v-.5c0-.277-.223-.5-.5-.5zm-10 6.002c-.25-.002-.5.162-.5.498v2c0 .276.224.5.5.5h2c.656 0 .672-1 0-1H3v-1.5c0-.328-.25-.496-.5-.498zm20 0c-.25.002-.5.17-.5.498V21h-1.5c-.672 0-.656 1 0 1h2c.276 0 .5-.224.5-.5v-2c0-.336-.25-.5-.5-.498z"/>
                          </svg>
                        </a>
      
                      </div>                
                      
      
                  </div>

                  <br/>

                  <div className="row"> 

                      <div className="col-sm-3">
             
                        <a type="button" id="btn-options" class="btn btn-secondary btn-lg" href="/horarios">Horarios de Atención <br/>
                           <svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" class="bi bi-clock-fill" viewBox="0 0 16 16">
                             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                           </svg>
                        </a>
             
                      </div> 
      
      
                      <div className="col-sm-3">
             
                        <a type="button" id="btn-options" class="btn btn-secondary btn-lg" href="/servicios_facturacion">Crear Servicios <br/>
                         <svg fill="currentColor" height="3em" viewBox="0 0 63 63" width="3em" xmlns="http://www.w3.org/2000/svg">
                           <path d="M61.493,41.902l-1.624-3.073C59.946,38.564,60,38.289,60,38c0-0.771-0.301-1.468-0.78-2c0.48-0.532,0.78-1.229,0.78-2   s-0.301-1.468-0.78-2c0.48-0.532,0.78-1.229,0.78-2c0-0.395-0.081-0.77-0.22-1.116C61.055,28.538,62,27.383,62,26   c0-1.654-1.346-3-3-3h-0.277l2.882-5.042C61.863,17.506,62,16.991,62,16.469V16c0-1.654-1.346-3-3-3   c-1.506,0-2.32,0.724-2.915,1.252C55.578,14.703,55.243,15,54.497,15c-0.745,0-1.08-0.297-1.587-0.748   C52.315,13.724,51.501,13,49.995,13c-1.505,0-2.319,0.724-2.914,1.252C46.574,14.703,46.24,15,45.495,15   c-0.743,0-1.077-0.297-1.582-0.747C43.318,13.724,42.505,13,41,13c-1.654,0-3,1.346-3,3v0.469c0,0.522,0.137,1.037,0.396,1.488   L39.563,20h-1.327c-1.097,0-2.192,0.19-3.236,0.529V6c0-2.757-2.243-5-5-5H6C3.243,1,1,3.243,1,6v52c0,2.757,2.243,5,5,5h24   c2.757,0,5-2.243,5-5V38.811c0.171,0.086,0.346,0.162,0.511,0.261l0.949,0.57c0.832,0.499,1.737,0.851,2.672,1.076l-0.625,1.183   C37.521,43.767,37,45.867,37,48c0,7.168,5.832,13,13,13s13-5.832,13-13.024C63,45.867,62.479,43.767,61.493,41.902z M40,16   c0-0.551,0.448-1,1-1c0.743,0,1.078,0.297,1.583,0.747C43.178,16.276,43.991,17,45.495,17c1.505,0,2.319-0.724,2.914-1.252   C48.916,15.297,49.25,15,49.995,15s1.08,0.297,1.587,0.748C52.177,16.276,52.991,17,54.497,17s2.321-0.724,2.916-1.252   C57.92,15.297,58.255,15,59,15c0.552,0,1,0.449,1,1v0.469c0,0.174-0.046,0.345-0.132,0.496L56.42,23H43.58l-3.448-6.036   C40.046,16.814,40,16.643,40,16.469V16z M6,3h24c1.654,0,3,1.346,3,3v3H3V6C3,4.346,4.346,3,6,3z M30,61H6c-1.654,0-3-1.346-3-3v-3   h30v3C33,59.654,31.654,61,30,61z M33,53H3V11h30v10.343c-0.642,0.265-1.313,0.453-2,0.555V13H5v38h26V38h0.639   c0.459,0,0.913,0.057,1.361,0.14V53z M15,20v20h12v-2h2v11H7V15h22v7h-2v-2H15z M21,26v12h-4V22h4v2h2v-2h2v16h-2V26H21z    M36.54,37.357C35.06,36.469,33.364,36,31.639,36H27V24h2.764c1.617,0,3.237-0.382,4.684-1.105c1.17-0.585,2.48-0.895,3.789-0.895   h2.469l1.714,3H59c0.552,0,1,0.449,1,1s-0.448,1-1,1h-2h-6h-6v2h6h6c0.552,0,1,0.449,1,1s-0.448,1-1,1h-6h-6v2h6h6   c0.552,0,1,0.449,1,1s-0.448,1-1,1H45v2h12c0.552,0,1,0.449,1,1s-0.448,1-1,1H41.361c-1.363,0-2.703-0.371-3.872-1.072   L36.54,37.357z M50,59c-6.065,0-11-4.935-11-11.024c0-1.784,0.44-3.562,1.274-5.139l0.974-1.844c0.038,0,0.075,0.008,0.112,0.008   H57c0.56,0,1.078-0.164,1.527-0.432l1.199,2.268C60.56,44.414,61,46.191,61,48C61,54.065,56.065,59,50,59z" /><path d="M50,47c0.552,0,1,0.449,1,1h2c0-1.302-0.839-2.402-2-2.816V43h-2v2.184c-1.161,0.414-2,1.514-2,2.816c0,1.654,1.346,3,3,3   c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1h-2c0,1.302,0.839,2.402,2,2.816V57h2v-2.184c1.161-0.414,2-1.514,2-2.816   c0-1.654-1.346-3-3-3c-0.552,0-1-0.449-1-1S49.448,47,50,47z" />
                           <rect height={2} width={8} x={14} y={5} /><rect height={2} width={2} x={24} y={5} /><rect height={2} width={2} x={10} y={5} /><rect height={2} width={6} x={15} y={57} />
                         </svg>
                        </a>
             
                      </div>  

                      <div className="col-sm-3">
             
                        <a type="button" id="btn-options" class="btn btn-secondary btn-lg" href="/sedes">Crear Sedes <br/>
                         <svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" class="bi bi-house-fill" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
                           <path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
                         </svg>
                        </a>
             
                      </div> 

                      <div className="col-sm-3">
             
                        <a type="button" id="btn-options" class="btn btn-secondary btn-lg" href="/convenios">Convenios <br/>
                         <svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" viewBox="0 0 570 570">{/*!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.*/}
                            <path d="M32 48C32 21.5 53.5 0 80 0l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-32 0c-17.7 0-32-14.3-32-32S238.3 0 256 0l48 0c26.5 0 48 21.5 48 48l0 144c0 77.4-55 142-128 156.8l0 19.2c0 61.9 50.1 112 112 112s112-50.1 112-112l0-85.5c-37.3-13.2-64-48.7-64-90.5 0-53 43-96 96-96s96 43 96 96c0 41.8-26.7 77.4-64 90.5l0 85.5c0 97.2-78.8 176-176 176S160 465.2 160 368l0-19.2C87 334 32 269.4 32 192L32 48zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
                        </svg>

                        </a>
             
                      </div>             
       
      
                  </div>

                  <br/>

                  <div className="row"> 

                      <div className="col-sm-3">
             
                        <a type="button" id="btn-options" class="btn btn-secondary btn-lg" href="/agendas">Crear Agenda <br/>
                          <svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" viewBox="0 0 570 570">{/*!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.*/}
                            <path d="M216 64C229.3 64 240 74.7 240 88L240 128L400 128L400 88C400 74.7 410.7 64 424 64C437.3 64 448 74.7 448 88L448 128L480 128C515.3 128 544 156.7 544 192L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 192C96 156.7 124.7 128 160 128L192 128L192 88C192 74.7 202.7 64 216 64zM480 496C488.8 496 496 488.8 496 480L496 416L408 416L408 496L480 496zM496 368L496 288L408 288L408 368L496 368zM360 368L360 288L280 288L280 368L360 368zM232 368L232 288L144 288L144 368L232 368zM144 416L144 480C144 488.8 151.2 496 160 496L232 496L232 416L144 416zM280 416L280 496L360 496L360 416L280 416zM216 176L160 176C151.2 176 144 183.2 144 192L144 240L496 240L496 192C496 183.2 488.8 176 480 176L216 176z" />
                          </svg>
                        </a>
             
                      </div>                     
      
                  </div>
      
                   
          
                 </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
      
             
            </div>
          </div>
    {/* /.card */}
  </div>     
        
               
              
            </div>

</div>


      
      
    )

  }
  
}



export default Ajustes;